import React from 'react';
import {Link} from 'react-router';

var l = {};

l['norwegian'] = {
    continue:'Fortsett',
};

l['english'] = {
    continue:'Continue',
};



const NoResult = ({info,language,title,description,children,handleContinue,error}) => (
    <div>
        <h1>{title}</h1>
        <span className="description">{description}</span>

        {error ?
        <div className="m-t-10 m-b-10">
            <div className="alert dark alert-icon alert-danger alert-dismissible" role="alert">
                <i className="icon wb-close" aria-hidden="true"></i> {error}
            </div>
        </div>:null}

        {info ?
        <div className="m-t-10 m-b-10">
            <div className="alert dark alert-icon alert-warning alert-dismissible" role="alert">
                <i className="icon wb-alert" aria-hidden="true"></i> {info}
            </div>
        </div>:null}

        <div className="m-t-20">
            {children}
        </div>

        <div className="m-t-20 col-sm-12 text-center">
            <button className="btn btn-dark btn-lg" onClick={handleContinue}>{l[language].continue} <i className="icon wb-arrow-right"></i></button>
        </div>
    </div>
);

export default NoResult;



// WEBPACK FOOTER //
// ./containers/setup/Step.js